import script from "./table.vue?vue&type=script&setup=true&lang=js"
export * from "./table.vue?vue&type=script&setup=true&lang=js"

import "./table.vue?vue&type=style&index=0&id=a1c81e5e&lang=scss&scoped=true"
import "./table.vue?vue&type=style&index=1&id=a1c81e5e&lang=scss"

import exportComponent from "D:\\Work\\tatu\\tatu_25_5_24\\3.1源代码_25_4_3\\前端-源代码\\smart-battery-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1c81e5e"]])

export default __exports__